import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Coins, Loader2, Users, Trash2, Plus, ArrowRight, X, Clock, MapPin, Crosshair, Send, Check, AlertCircle, DollarSign } from "lucide-react";

export default function ConfirmCompletionModal({
  showConfirmDialog, setShowConfirmDialog, confirmForm, setConfirmForm,
  handleConfirmBounty, handleConfirmExpedition
}) {
  return (
      <Dialog open={!!showConfirmDialog} onOpenChange={() => setShowConfirmDialog(null)}>
        <DialogContent className="bg-slate-900 border-green-500/30 max-w-lg">
          <DialogHeader>
            <DialogTitle className="text-green-400">Confirm Completion</DialogTitle>
            <DialogDescription className="text-green-200/60">
              Confirm that the {showConfirmDialog?.type} has been completed successfully
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4">
            <div>
              <Label className="text-green-200">Comment (optional)</Label>
              <Textarea
                placeholder="Leave a comment..."
                value={confirmForm.comment}
                onChange={(e) => setConfirmForm({ ...confirmForm, comment: e.target.value })}
                className="bg-black/40 border-gray-600"
              />
            </div>

            <p className="text-sm text-gray-400">
              Both parties must confirm for the {showConfirmDialog?.type} to be marked as successful.
              Both will receive +1 reputation upon mutual confirmation.
            </p>
          </div>

          <DialogFooter>
            <Button variant="ghost" onClick={() => setShowConfirmDialog(null)}>Cancel</Button>
            <Button
              className="bg-green-500 hover:bg-green-600 text-black"
              onClick={() => {
                if (showConfirmDialog?.type === "bounty") {
                  handleConfirmBounty(showConfirmDialog.id);
                } else {
                  handleConfirmExpedition(showConfirmDialog.id);
                }
              }}
            >
              <Check className="w-4 h-4 mr-2" />
              Confirm Completion
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>  );
}
